import React, { FunctionComponent } from 'react'
import styles from './Aside.module.sass'
import { Resizable } from 're-resizable'
import clsx from 'clsx'
import { useRootDispatch, useRootSelector } from '../../../utils/hooks'
import { systemActions } from '../../../redux/global/system'
import { useQueries } from '../../../utils/hooks/useQueries'

interface Props {
    className?: string,
}

const Aside: FunctionComponent<Props> = props => {
    const dispatch = useRootDispatch()
    const ratio = useRootSelector(state => state.global.system.asideRatio)
    const width = window.innerWidth * ratio
    const { isMobile } = useQueries()

    return <Resizable
        className={clsx(props.className, styles.aside)}
        maxWidth={'40vw'}
        minWidth={isMobile? '85vw': undefined}
        enable={{ left: true }}
        size={{ width, height: 'auto' }}
        onResizeStop={(event, direction, elementRef, delta) =>
            dispatch(systemActions.setAsideRatio(window.innerWidth / (width + delta.width)))}
    >
        {props.children}
    </Resizable>
}

export default Aside